export enum Weekday {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
};

export function getCurrentWeekday() : Weekday {
  const today = new Date().getDay();
  return (today) as Weekday;
}

export function getWeekdayShortTranslationIndex(weekday: Weekday): string {
  if (weekday === Weekday.MONDAY) { return "weekday.short.monday"; }
  if (weekday === Weekday.TUESDAY) { return "weekday.short.tuesday"; }
  if (weekday === Weekday.WEDNESDAY) { return "weekday.short.wednesday"; }
  if (weekday === Weekday.THURSDAY) { return "weekday.short.thursday"; }
  if (weekday === Weekday.FRIDAY) { return "weekday.short.friday"; }
  if (weekday === Weekday.SATURDAY) { return "weekday.short.saturday"; }
  if (weekday === Weekday.SUNDAY) { return "weekday.short.sunday"; }
  return "";
}
